import { TableStatus } from '@/common/types/phenomTypes';

interface TableStatusIndicatorProps {
  status?: string;
  hideLabel?: boolean;
}

// Similar to TournamentStatusIndicator but for individual tables
const TableStatusIndicator = ({ status, hideLabel = false }: TableStatusIndicatorProps) => {
  const statusColor = () => {
    switch (status) {
      case TableStatus.RUNNING:
        return 'success';
      case TableStatus.STOPPED:
        return 'danger';
      default:
        return 'secondary';
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-start gap-2">
      <div className={`bg-${statusColor()} rounded-circle`} style={{ width: '15px', height: '15px' }} />
      {!hideLabel && <p className={`mb-0 text-${statusColor()}`}>{status ?? 'UNKNOWN'}</p>}
    </div>
  );
};

export default TableStatusIndicator;
